/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetauto2Inputs */

const en_filterpresetauto2 = /** @type {(inputs: Filterpresetauto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const de_filterpresetauto2 = /** @type {(inputs: Filterpresetauto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Filterpresetauto2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetauto2 = /** @type {((inputs?: Filterpresetauto2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetauto2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetauto2(inputs)
	return de_filterpresetauto2(inputs)
});
export { filterpresetauto2 as "filterPresetAuto" }